import { NSARouterMakerResult } from 'namirasoft-account-react';
import { ProductRow } from 'namirasoft-payment';
import { IBaseComponentProps, NSCard, NSLoading, NSNoData, NSSection } from 'namirasoft-site-react';
import { useEffect, useState } from 'react';
import { PaymentLayout } from '../PaymentLayout';
import { PaymentProps } from '../PaymentProps';
import { PaymentRoutes } from '../PaymentRoutes';

export interface ProductListPageProps extends NSARouterMakerResult, PaymentProps, IBaseComponentProps
{ }

export interface ProductListPageState
{
	products: ProductRow[];
	isLoading: boolean;
}

export default function ProductListPage(props: ProductListPageProps)
{
	let [state, setState] = useState<ProductListPageState>({ products: [], isLoading: true })

	useEffect(() =>
	{
		props.servers.payment.product.List(null, null, null, [], null).then((res) =>
		{
			setState({ products: res.rows, isLoading: false });
		}).catch(() => { });
		// eslint-disable-next-line react-hooks/exhaustive-deps 
	}, []);

	return (
		<PaymentLayout {...props}
			action={{
				description: "This section displays all Namirasoft paid products that are available for sale."
			}}
		>
			<div
				id={props.id}
				className={`${"d-flex gap-3 flex-wrap justify-content-center container"} ${props.classList?.join(" ")}`}
				style={props.style}
			>
				{
					state.products.length !== 0 ?
						state.products.map((product: ProductRow) =>
							<>
								<NSCard
									key={product.id}
									link={{ href: PaymentRoutes.SalesItemList(product.slug, true, ""), target: "_self" }}
									title={product.name}
									image={{ src: product.logo ?? '', alt: product.name }}
								/>
							</>
						)
						:
						<NSSection>
							{
								state.isLoading ? <NSLoading /> : <NSNoData classList={["p-3"]} lable='Currently, there are no data available. Please check back later for updates.' />
							}
						</NSSection>
				}
			</div>
		</PaymentLayout>
	);
}